/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_footer_open_source = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Source`)
};

const zh_hans1_footer_open_source = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源`)
};

const zh_hant1_footer_open_source = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開源`)
};

const fr_footer_open_source = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source`)
};

const de_footer_open_source = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Source`)
};

const ja_footer_open_source = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オープンソース`)
};

const ko_footer_open_source = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오픈 소스`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer_open_source = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_open_source(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_open_source", locale)
	if (locale === "en") return en_footer_open_source(inputs)
	if (locale === "zh-Hans") return zh_hans1_footer_open_source(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_open_source(inputs)
	if (locale === "fr") return fr_footer_open_source(inputs)
	if (locale === "de") return de_footer_open_source(inputs)
	if (locale === "ja") return ja_footer_open_source(inputs)
	return ko_footer_open_source(inputs)
};